import { makeStyles } from '@material-ui/core';
import React, { FC } from 'react';
import { importPevUrl } from '../../api/rtk/ExamSessionApi';
import UploadDropZone from '../common/UploadDropZone';
import CustomDraggableDialog from '../common/customDialog/CustomDraggableDialog';
import TranslatedMessage from '../translations/TranslatedMessage';

interface ImportPevDialogProps {
    isOpen: boolean;
    onFileUploaded: () => void;
    onClose: () => void;
}

const useStyles = makeStyles(() => ({
    dropZoneDiv: {
        width: '100%',
        margin: '0 auto'
    }
}));

const ImportPevDialog: FC<ImportPevDialogProps> = ({ isOpen, onFileUploaded, onClose }) => {
    const classes = useStyles();
    return <CustomDraggableDialog
        hideActions={true}
        onClose={onClose}
        acceptText={<TranslatedMessage id="common.accept" />}
        cancelText={<TranslatedMessage id="common.cancel" />}
        content={<React.Fragment>
            <div className={classes.dropZoneDiv}>
                <UploadDropZone
                    accept=".csv"
                    onFileUploaded={onFileUploaded}
                    uploadURL={importPevUrl}
                />
            </div>
        </React.Fragment>
        }
        isOpen={isOpen}
        title={<TranslatedMessage id="examSession.importPevDialog.title" />} />;
};

export default ImportPevDialog;